// extracted by css-extract-rspack-plugin
export default {"gridColumnTemplate":"HiddenDiffPatch-module__gridColumnTemplate__o4otv"};